/**
 * The printed page around a report: paper, margins and the running items
 * FrameTracker repeats on every page (print date, company, User:, Page n of N).
 *
 * Those go in CSS paged-media margin boxes (@top-left ... @bottom-right), the
 * only way a browser repeats text on every printed page and counts pages.
 * Chrome and Edge 131+ draw them; a browser without margin-box support prints
 * the report without them. The rule is injected while a report is on screen and
 * removed when it leaves, so nothing else in the admin app prints with it.
 */

const STYLE_ID = 'ft-report-print-page'
const BOXES = {
    topLeft: 'top-left', topCenter: 'top-center', topRight: 'top-right',
    bottomLeft: 'bottom-left', bottomCenter: 'bottom-center', bottomRight: 'bottom-right',
}

function cssString(text) {
    return '"' + String(text).replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/[\r\n]+/g, ' ') + '"'
}

/**
 * A page-number format as CSS content: 'Page n of N' becomes
 * "Page " counter(page) " of " counter(pages). A standalone n is the page, N the
 * page count; everything else is literal.
 */
export function pageNumberContent(format) {
    const parts = String(format).split(/\b([nN])\b/)
    return parts
        .map((part, i) => {
            if (i % 2 === 1) return part === 'n' ? 'counter(page)' : 'counter(pages)'
            return part === '' ? '' : cssString(part)
        })
        .filter(p => p !== '')
        .join(' ')
}

/**
 * Sets the printed page. `boxes` maps topLeft/topCenter/topRight/bottomLeft/
 * bottomCenter/bottomRight to {text} (literal) or {pages: 'Page n of N'}, with
 * optional `bold`, `italic` and `size` (pt).
 */
export function setPrintPage({size = 'letter', margin = '12mm', boxes = {}} = {}) {
    let style = document.getElementById(STYLE_ID)
    if (!style) {
        style = document.createElement('style')
        style.id = STYLE_ID
        document.head.appendChild(style)
    }

    const rules = Object.keys(boxes)
        .filter(key => BOXES[key] && boxes[key])
        .map(key => {
            const box = boxes[key]
            const content = box.pages !== undefined ? pageNumberContent(box.pages) : cssString(box.text || '')
            const font = (box.italic ? 'italic ' : '') + (box.bold ? 'bold ' : '') + (box.size || 9) + 'pt Arial, sans-serif'
            return '@' + BOXES[key] + ' { content: ' + content + '; font: ' + font + '; color: #000; }'
        })

    style.textContent = '@media print { @page { size: ' + size + '; margin: ' + margin + '; ' + rules.join(' ') + ' } }'
}

export function clearPrintPage() {
    const style = document.getElementById(STYLE_ID)
    if (style) style.parentNode.removeChild(style)
}
